export default "/static/webpack/media/dots.bc6261b2.svg";